import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

// Determine whether our node is the child of an autocomplete
const isInAutoComplete = function (editor) {
	return !!editor.dom.getParents(editor.selection.getNode(), '#autocomplete-search-text').length;
};

// Determine whether our node contains ONLY a zero width space
const isEmptyElement = function (editor, textNode) {
	return textNode.nodeValue.length == 1 && editor.selection.getNode().childNodes.length == 1;
};

/**
 * Returns true if the cursor is at the end of the given range.
 */
const isCursorAtEnd = function (ed, rng, node) {
	if (!ed.selection.getSel().isCollapsed) {
		return false;
	}

	// compareEndPoints is only supported by <= IE8
	if (rng.compareEndPoints) {
		const tempTextRange = ed.getBody().createTextRange();
		tempTextRange.moveToElementText(node);
		tempTextRange.collapse(0);
		return rng.compareEndPoints('EndToEnd', tempTextRange) === 0;
	}

	const endContainer = rng.endContainer;
	if (endContainer.nodeType === 3) {
		return endContainer.wholeText.length == rng.endOffset;
	}

	const elementAfterCursor = endContainer.childNodes[rng.endOffset];
	return $(elementAfterCursor).is(':last-child');
};

// Textpatterns is the place where we refine desired behaviours based on Dom situation and user interaction
const handleDeleteZeroWidthChar = function (editor) {
	// Check if we are on a zerowidth character when delete is pressed,
	// if we are then move the selection to the previous textnode (left), and remove the zerowidth char.
	// this prevents having to press delete twice, as the first is consumed by the zerowidth char.
	if (
		editor.selection.isCollapsed() &&
		editor.selection.selectedRange &&
		!isInAutoComplete(editor)
	) {
		const textNode = getTextNode(editor.selection.selectedRange);
		if (
			textNode &&
			textNode.nodeValue &&
			textNode.nodeValue.charCodeAt(0) === 65279 &&
			isEmptyElement(editor, textNode)
		) {
			editor.undoManager.ignore(() => {
				moveCursorLeftOf(editor, textNode);
				textNode.parentNode.removeChild(textNode);
			});
		}
	}
};

// CONFCLOUD-57238 move cursor out of the link node on space key press to prevent emoticon being lost upon publish
const handleZeroWidthChar = function (ed) {
	const selectedNode = ed.selection.getNode();
	const anchor = $(selectedNode).closest('a');
	const rng = ed.selection.getRng();

	if (anchor.length && isCursorAtEnd(ed, ed.selection.getRng(), selectedNode)) {
		rng.setStartAfter(anchor[0]);
		rng.setEndAfter(anchor[0]);
		ed.selection.setRng(rng);
		ed.selection.collapse();
	}
};

const getTextNode = function (sRange) {
	const offset = sRange.endOffset;
	return sRange.endContainer.nodeType === 3
		? sRange.endContainer
		: sRange.endContainer.childNodes[offset - 1];
};

const moveCursorLeftOf = function (editor, currentNode) {
	if (currentNode && currentNode.previousSibling && currentNode.previousSibling.hasChildNodes()) {
		const previousNode = currentNode.previousSibling;
		const last = previousNode.childNodes.length;
		const prevNode = previousNode.childNodes[last - 1];
		const offset = prevNode.length;

		const rng = editor.dom.createRng();
		rng.setStart(prevNode, offset);
		rng.setEnd(prevNode, offset);
		editor.selection.setRng(rng);
	}
};

const plugger = {
	init(editor) {
		editor.on('KeyDown', (e) => {
			if (!window.tinymce.VK.modifierPressed(e) && e.keyCode === 32) {
				// handle space key
				handleZeroWidthChar(editor);
			}
			if (!window.tinymce.VK.modifierPressed(e) && (e.keyCode === 8 || e.keyCode === 37)) {
				handleDeleteZeroWidthChar(editor);
			}
		});
	},
};

export default function textPattern() {
	window.tinymce.create('tinymce.plugins.TextPatternPlugin', plugger);
	window.tinymce.PluginManager.add('aetextpattern', window.tinymce.plugins.TextPatternPlugin);
}
